import {enableES5} from 'immer';

export default () => enableES5();
